export default {
  upgrade: "Upgrade",
  alertTitle: "Upgrade Plan",
  trialMessage: "The max number of collaborators is 50.",
  singleMessage: "You currently have the Single Plan. You can add 5 collaborators. To add more collaborators upgrade your plan.",
  basicMessage: "You are currently subscribed to the Basic Plan. The max number of collaborators is 50.",
  standardMessage: "You are currently subscribed to the Standard Plan. The max number of collaborators is 50.",
  permierMessage: "You are currently subscribed to the Premier Plan. The max number of collaborators is 50.",
  mobileMessage: "View your account on the web to manage and enable more events or collaborators.",
};



// WEBPACK FOOTER //
// ./src/views/user/agenda/collaborators/Collaborators.messages.js